// AUTO-GENERATED from Firestore dump. Do not edit by hand.
// Source: scripts/build-static-config.mjs (config version 23)

import type { TvmFormDefinition } from "../types";

const form: TvmFormDefinition = {
	"formula": {
		"netOpening": "(distanceBtWindTips/100)*headropeLength",
		"__cond": {
			"distanceBtWindTips>=20&&distanceBtWindTips<=40": "#ffcdd2",
			"distanceBtWindTips>=68&&distanceBtWindTips<=79": "#fff9c4",
			"distanceBtWindTips>=80&&distanceBtWindTips<=90": "#ffcdd2",
			"distanceBtWindTips>=41&&distanceBtWindTips<=55": "#fff9c4",
			"distanceBtWindTips>=56&&distanceBtWindTips<=67": "#c8e6c9"
		},
		"gatesSweepArea": "((((((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)*(sqrt(((netLength+windLength+malletasLength+pieDeGalloLength)**2)-(((((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)/2)**2))))/2))*2",
		"distanceBtWindTips": "distanceBtWindTips",
		"doorOpening": "(((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)*2",
		"strikeAngle": "asin(((((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)/2)/(netLength+windLength+malletasLength+pieDeGalloLength))",
		"filteredWaterVolume": "((trawlSpeed*0.516)*(((distanceBtWindTips/100)*headropeLength)*verticalNetOpening*0.75))*2"
	},
	"fields": {
		"verticalNetOpening": {
			"value": 0,
			"name": "verticalNetOpening",
			"type": "INPUT",
			"index": 6,
			"label": "$form_trawl_systems_vertical_aperture",
			"inputType": "number"
		},
		"netLength": {
			"value": 0,
			"name": "netLength",
			"inputType": "number",
			"type": "INPUT",
			"index": 1,
			"label": "$form_trawl_systems_net_long"
		},
		"distanceBtWindTips": {
			"value": 10,
			"name": "distanceBtWindTips",
			"type": "INPUT",
			"index": 7,
			"label": "$form_trawl_systems_headrope_aperture",
			"range": {
				"step": 1,
				"max": 90,
				"min": 10
			},
			"inputType": "range-bar"
		},
		"windLength": {
			"inputType": "number",
			"type": "INPUT",
			"index": 3,
			"label": "$form_trawl_systems_bridle_length",
			"value": 0,
			"name": "windLength"
		},
		"headropeLength": {
			"value": 0,
			"name": "headropeLength",
			"inputType": "number",
			"type": "INPUT",
			"index": 2,
			"label": "$form_trawl_systems_headrope_length"
		},
		"pieDeGalloLength": {
			"name": "pieDeGalloLength",
			"value": 0,
			"index": 5,
			"label": "$form_trawl_systems_backstrop_length",
			"type": "INPUT",
			"inputType": "number"
		},
		"trawlSpeed": {
			"label": "$form_trawl_systems_speed",
			"index": 0,
			"type": "INPUT",
			"inputType": "number",
			"name": "trawlSpeed",
			"value": 0
		},
		"malletasLength": {
			"inputType": "number",
			"index": 4,
			"label": "$form_trawl_systems_sweepline",
			"type": "INPUT",
			"name": "malletasLength",
			"value": 0
		}
	},
	"hints": {
		"htmlDef": "<div style=\"display: block; margin-bottom: 1rem; font-family: Helvetica; font-size: 20px;\">     <div>     <div style=\"width: 2rem;height: 1rem;background-color: #c8e6c9;border: 1px solid;display: inline-block;margin-right: 1rem;\"><br></div>     <span style=\"line-height: 1.5; \">{{form_trawl_systems_hints_p1}}</span>           </div>     <div>     <div style=\"width: 2rem;height: 1rem;background-color: #fff9c4;border: 1px solid;display: inline-block;margin-right: 1rem;\"><br></div>     <span style=\"line-height: 1.5; \">{{form_trawl_systems_hints_p2}}</span>        </div>     <div>     <div style=\"width: 2rem;height: 1rem;background-color: #ffcdd2;border: 1px solid;display: inline-block;margin-right: 1rem;\"><br></div>     <span style=\"line-height: 1.5; \">{{form_trawl_systems_hints_p3}}<br>        </div>     <p><strong>{{form_trawl_systems_hints_p4}}</strong></p>     <ol>     <li>{{form_trawl_systems_hints_p5}}</li>     <li>{{form_trawl_systems_hints_p6}}</li>     <li>{{form_trawl_systems_hints_p7}}</li>     <li>{{form_trawl_systems_hints_p8}}</li>     <li>{{form_trawl_systems_hints_p9}}</li>     <li>{{form_trawl_systems_hints_p10}}</li>     <li>{{form_trawl_systems_hints_p11}}</li>     <li>{{form_trawl_systems_hints_p12}}</li>     <li>{{form_trawl_systems_hints_p13}}<br></li>     <br>       </ol>     <p><strong>{{form_trawl_systems_hints_p14}}</strong></p>     <ol>     <li>{{form_trawl_systems_hints_p15}}</li>     <li>{{form_trawl_systems_hints_p16}}</li>     <li>{{form_trawl_systems_hints_p17}}</li>     <li>{{form_trawl_systems_hints_p18}}</li>     <li>{{form_trawl_systems_hints_p19}}</li>     <li>{{form_trawl_systems_hints_p20}}</li>     <li>{{form_trawl_systems_hints_p21}}</li>     <li>{{form_trawl_systems_hints_p22}}</li>     <li>{{form_trawl_systems_hints_p23}}</li>     </ol> </div>",
		"title": "Doble 3 cables"
	}
};

export const tripleTow = form;
